import moment from "moment"
import React, { useState } from "react"
import { Col, FormGroup, Input, InputGroup, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import ToggleButton from "../../../common/ToggleButton"
import { ValueText } from "../ProductAdd"
import { ProductStatus, ProductType } from "../ProductList"
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import profilePic from '../../../assets/images/users/no-img.jpg'
import NumberFormat from "react-number-format"
import Select, { components } from 'react-select'
import { usageList, usedUnits } from "./ProductInfo"
import { WithContext as ReactTags } from 'react-tag-input'
import TextUtils from "../../../helpers/TextUtils";
import AsyncSelect from "react-select/async";


const ProductViewInfo = (props: any) => {
    const { data, imgs, setData, type, onlyView, handleChangeInput, category, brand, origin, age, pathologicals } = props
    const [isOpen, setIsOpen] = useState(false);
    const [imgIndex, setImgIndex] = useState(0);
    const [descriptionStatus, setDescriptionStatus] = useState(false);

    let images = imgs?.reduce((prev: any, item: any) => {
        prev = [...prev, {
            title: data?.name,
            caption: data?.name,
            url: item?.url,
        }]
        return prev
    }, [])

    if (images?.length === 0) {
        images = [{
            title: data?.name,
            caption: data?.name,
            url: profilePic,
        }]
    }

    const handleFilterMulti = (name: string, option: any, onChange: any) => {
        const value: any = []
        option && option.map((item: any) => {
            value.push(item.value)
        })
        onChange({ target: { name, value } })

    }

    const getFilterMulti = (list: any, value: any) => {
        if (value instanceof Array) {
            const option: any = []
            list && list.map((item: any) => {
                const found = value.length > 0 && value.find((element: any) => element == item.value);
                if (found || found === 0) {
                    option.push(item)
                }
            })
            return option
        }
        return []
    }

    const KeyCodes = {
        comma: 188,
        enter: 13
    };

    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const setTags = (value: any) => {
        handleChangeInput({ target: { name: 'ingredient', value } })
    }

    const handleDelete = (i: any) => {
        const item = data?.ingredient[i]
        setTags(data?.ingredient.filter((tag: any, index: number) => index !== i));
    };

    const handleAddition = (tag: any) => {
        setTags([...data?.ingredient, {
            ...tag,
            name: tag?.text,
        }]);
    };

    const handleTagClick = (index: number) => {
        console.log('The tag at index ' + index + ' was clicked');
    };
    
    return (
        <PageBody>
            <div className="nutri-title mb-3">Thông tin sản phẩm</div>
            <Row>
                <Col md={images?.length === 1 ? 2 : 4} xs={12}>
                    <div className="nutri-imgae-prevew">
                        {images?.map((item: any, index: number) => {
                            if (index > 1) return null
                            return (<div key={`images-${index}`} className={`nutri-imgae-prevew-item ${images?.length === 1 ? 'only-avatar' : ''}`} onClick={() => setIsOpen(true)}>
                                <img src={item?.url} />
                                {(images?.length === 1 || index === 1) && images?.length - 1 >= 1 &&
                                    <span>
                                        + {images?.length - 1}
                                    </span>
                                }
                            </div>)
                        })}
                    </div>
                    {isOpen && (
                        <Lightbox
                            imageTitle={images[imgIndex].title}
                            imageCaption={images[imgIndex].caption}
                            mainSrc={images[imgIndex].url}
                            nextSrc={images[(imgIndex + 1) % images.length].url}
                            prevSrc={images[(imgIndex + images.length - 1) % images.length].url}
                            onCloseRequest={() => setIsOpen(false)}
                            onMovePrevRequest={() =>
                                setImgIndex((imgIndex + images.length - 1) % images.length)
                            }
                            onMoveNextRequest={() => setImgIndex((imgIndex + 1) % images.length)}
                        />
                    )}
                </Col>
                <Col md={images?.length === 1 ? 10 : 8} xs={12}>
                    <Row>
                        <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Mô tả sản phẩm</Label>
                                <InputGroup style={{
                                    overflow: 'hidden',
                                    height: descriptionStatus ? 'auto' : 100
                                }}>
                                    {data?.description || '---'}
                                </InputGroup>
                                {data?.description?.length > 400 &&
                                    <div className="text-info" onClick={() => setDescriptionStatus(!descriptionStatus)}>{!descriptionStatus ? 'Xem chi tiết' : 'Thu gọn'}</div>}
                            </FormGroup>
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Thương hiệu</Label>
                                        <InputGroup>
                                            {data?.brand_text|| '---'}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Xuất xứ</Label>
                                        <InputGroup>
                                            {data?.origin_text || '---'}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Kiểu quản lý</Label>
                                        <InputGroup>
                                            {data?.type === 'normal' ? 'Thường' : 'Theo lô'}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Người tạo</Label>
                                        <ValueText>{!data?.created_uid ? "---" : data?.created_uid?.name}</ValueText>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Thời gian tạo</Label>
                                        <ValueText>{!data?.created_time ? "---" : moment(data?.created_time).format('HH:mm:ss DD/MM/YYYY')}</ValueText>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Thời gian cập nhật</Label>
                                        <ValueText>{!data?.updated_time ? "---" : moment(data?.updated_time).format('HH:mm:ss DD/MM/YYYY')}</ValueText>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6} xs={12}>
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Danh mục</Label>
                                        {!data?.category_id ? <ValueText>---</ValueText> :
                                            <Select
                                                placeholder={type === 'view' && !data?.category_id ? '---' : "Chọn danh mục"}
                                                className="react-select mb-2"
                                                classNamePrefix="react-select"
                                                isDisabled={onlyView}
                                                onChange={(val: any) => {
                                                    // setData({ ...data, category_id: val?.value })
                                                    handleChangeInput({ target: { name: 'category_id', value: val?.value } })
                                                }}
                                                value={category?.filter(
                                                    (option: any) => data?.category_id == option.value
                                                )}
                                                options={category}
                                                styles={{
                                                    ...customStyles,
                                                    menu: ({ width, ...css }) => ({
                                                        ...css,
                                                        minWidth: 300,
                                                    }),
                                                }}
                                            ></Select>}
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Loại sản phẩm</Label>
                                        {!data?.product_type ? <ValueText>---</ValueText> :
                                            <Select
                                                placeholder={type === 'view' && !data?.product_type ? '---' : "Chọn Loại sản phẩm"}
                                                className="react-select mb-2"
                                                classNamePrefix="react-select"
                                                isDisabled={onlyView}
                                                onChange={(val: any) => {
                                                    setData({ ...data, product_type: val?.value })
                                                }}
                                                value={ProductType?.filter(
                                                    (option: any) => data?.product_type == option.value
                                                )}
                                                options={ProductType}
                                                styles={{
                                                    ...customStyles,
                                                    menu: ({ width, ...css }) => ({
                                                        ...css,
                                                        minWidth: 300,
                                                    }),
                                                }}
                                            ></Select>}
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Đơn vị xuất kho</Label>
                                        {!data?.minimum_unit ? <ValueText>---</ValueText> :
                                            <InputGroup>
                                                <Input type="text" value={data?.minimum_unit} onChange={(e: any) => handleChangeInput(e)} name="minimum_unit" placeholder="Nhập đơn vị..." />
                                            </InputGroup>}
                                    </FormGroup>
                                </Col>

                            </Row>
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Loại đường dùng</Label>
                                        {data?.usage?.length === 0 ? <ValueText>---</ValueText> :
                                            <Select
                                                className="react-select mb-2"
                                                classNamePrefix="react-select"
                                                placeholder="Chọn loại đường dùng"
                                                options={usageList}
                                                isMulti
                                                isDisabled={onlyView}
                                                onChange={(val: any) => { handleFilterMulti('usage', val, handleChangeInput) }}
                                                value={data?.usage || []}
                                            ></Select>}
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span>Đơn vị sử dụng</Label>
                                        {!data?.used_unit ? <ValueText>---</ValueText> :
                                            <InputGroup>
                                                <Input type="text" value={TextUtils.getLabelByValue(usedUnits, data?.used_unit)} onChange={(e: any) => handleChangeInput(e)} name="used_unit" placeholder="Nhập đơn vị..." />
                                            </InputGroup>}
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Trạng thái</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.status ? '---' : "Chọn trạng thái"}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            onChange={(val: any) => {
                                                setData({ ...data, status: val?.value })
                                            }}
                                            value={ProductStatus?.filter(
                                                (option: any) => data?.status == option.value
                                            )}
                                            options={ProductStatus}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form only-view'>
                                    <Label><span>*</span>Độ tuổi</Label>
                                    <Select
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        placeholder="Chọn độ tuổi"
                                        options={age}
                                        isDisabled={onlyView}
                                        value={age?.filter((option: any) => option?.value == data?.product_age_id)}
                                    ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Bệnh lý</Label>
                                        <AsyncSelect
                                            isMulti = {true}
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            // onInputChange={handleChangePathologicals}
                                            // loadOptions={loadPathologicalsSearchs}
                                            // inputValue={queryPathologicals}
                                            placeholder='---'
                                            // noOptionsMessage={() => queryPathologicals ? "Không tìm thấy dữ liệu" : 'Tìm kiếm tên'}
                                            loadingMessage={() => 'Đang tìm kiếm...'}
                                            cacheOptions
                                            style={{ padding: 0 }}
                                            isDisabled={onlyView}
                                            value={data?.product_pathological_ids}
                                            defaultOptions={pathologicals}
                                            components={{
                                                Menu: (props: any) => (
                                                    <components.Menu {...props} >
                                                    {props.children}
                                                    </components.Menu>
                                                )
                                            }}
                                        ></AsyncSelect>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <FormGroup className='nutri-form'>
                                <Label>Thành phần</Label>
                                {data?.ingredient?.length === 0 ? <ValueText>---</ValueText> :
                                    <ReactTags
                                        delimiters={delimiters}
                                        tags={data?.ingredient}
                                        handleDelete={handleDelete}
                                        handleAddition={handleAddition}
                                        handleTagClick={handleTagClick}
                                        inputFieldPosition="bottom"
                                        autocomplete
                                        readOnly={type === 'view'}
                                        placeholder='Thêm giá trị...'
                                    />}
                            </FormGroup>
                            {/* <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Người tạo</Label>
                                        <ValueText>{!data?.created_uid ? "---":data?.created_uid?.name}</ValueText>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Thời gian tạo</Label>
                                        <ValueText>{!data?.created_time ? "---":moment(data?.created_time).format('HH:mm:ss DD/MM/YYYY')}</ValueText>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Thời gian cập nhật</Label>
                                        <ValueText>{!data?.updated_time ? "---":moment(data?.updated_time).format('HH:mm:ss DD/MM/YYYY')}</ValueText>
                                    </FormGroup>
                                </Col>
                            </Row> */}
                            {data?.type === 'batch' &&
                                <Row>
                                    <Col md={4} xs={12}>
                                        <FormGroup className='nutri-form'>
                                            <Label>Ngày đến hạn</Label>
                                            <InputGroup>
                                                {data?.expiration_day_number || '---'}
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4} xs={12}>
                                        <FormGroup className='nutri-form'>
                                            <Label>Ngày cảnh báo</Label>
                                            <InputGroup>
                                                {data?.warning_day_number || '---'}
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>}
                        </Col>
                        {/* <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Liều dùng</Label>
                                <InputGroup>
                                    {data?.dosage  || '---'}
                                </InputGroup>
                            </FormGroup>
                            <Row>
                                <Col md={6} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Ngày đến hạn</Label>
                                        <InputGroup>
                                            {data?.expiration_day_number  || '---'}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={6} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Loại sản phẩm</Label>
                                        <InputGroup>
                                            {ProductType?.filter(
                                                (option: any) => data?.product_type == option.value
                                            )[0]?.label}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Ngày cảnh báo</Label>
                                        <InputGroup>
                                            {data?.warning_day_number || '---'}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={6} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Trạng thái</Label>
                                        {
                                            type != 'view' ?
                                            <div style={{marginTop:10}}>
                                                <ToggleButton elmChecked={data?.status == 1 ? true : false} data={data} setData={(data:any) => setData(data)} name='status' />
                                            </div> :
                                            <ValueText className={data?.status == 1 ? 'text-success' : "text-danger"}>{data?.status == 1 ? 'Đang hoạt động' : "Vô hiệu hóa"}</ValueText>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col> */}
                    </Row>

                </Col>

            </Row>
        </PageBody>
    )
}

const customStyles = {
    menuList: (base: any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
    }),
};

export default ProductViewInfo